import { Fragment } from "react";
import { motion } from "framer-motion";
import {
  HiBuildingLibrary,
  HiShieldCheck,
  HiExclamationTriangle,
} from "react-icons/hi2";

import Nav from "../main/Nav";
import Footer from "../main/Footer";
import { bankName } from "../../util/config";
import adminUi from "./AdminUi.module.css";
import classes from "./ErrorModal.module.css";

const ErrorModal = () => {
  const message = "Something went wrong!";

  return (
    <Fragment>
      <header className={classes.errorHeader}>
        <div className={classes.errorHeaderInner}>
          <span className={classes.errorBrand}>
            <HiBuildingLibrary
              className={classes.errorBrandIcon}
              aria-hidden
            />
            {bankName}
          </span>
          <span className={classes.errorBadge}>
            <HiShieldCheck className={classes.errorBadgeIcon} aria-hidden />
            Administration
          </span>
        </div>
        <Nav />
      </header>
      <motion.main
        className={classes.errorMain}
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.25 }}
      >
        <div className={adminUi.page}>
          <div className={classes.errorCard}>
            <div className={classes.errorCardInner}>
              <HiExclamationTriangle
                className={classes.errorCardIcon}
                aria-hidden
              />
              <p>{message}</p>
            </div>
          </div>
        </div>
      </motion.main>
      <Footer />
    </Fragment>
  );
};

export default ErrorModal;
